import { API_VERSIONs, AuthVersion, E_ACCOUNT_TYPE } from '@features/auth/const';
import { API_ENDPOINTS } from './api.config';
import { environment } from './environments/environment';
import { GlobalPolcies } from './policy/policy.config';
import { ICoreAuthModuleConfig } from '@features/auth/core-auth.module';

export const AUTHEN_POLICY_UEF: ICoreAuthModuleConfig = {
  application: {
    appKey: environment.authen.appKey,
    apiVersion: API_VERSIONs.VERSION_2_0_0,
    authVersion: AuthVersion.VERSION_2,
    apiVersionHeader: 'X-Api-Version',
    tokenType: 'JWT',
    authDomain: API_ENDPOINTS.auth,
    fileV2: API_ENDPOINTS.permission_v2_file_v2,
    branch: 'UEF',
  },

  globalPolicies: GlobalPolcies,

  defaultAuth: {
    reCaptcha: {
      enable: true,
      secretKey: environment.authen.reCapchaSecretKey,
      enableReCaptchaAfterError: 5,
    },
    typeAccount: {
      useDefault: false, // Default NHAN_VIEN - SINH_VIEN
      enable: false,
    },
    loginByUsernameAndPassword: {
      enable: true,
    },
    client_sso: environment.client_sso
  },

  socialNetworkAuth: {
    facebook: {
      enable: false,
      secretKey: environment.authen.facebookAuthSecretKey,
      loginOptions: {
        scope:
          'pages_messaging,pages_messaging_subscriptions,email,pages_show_list,manage_pages',
        return_scopes: true,
        enable_profile_selector: true,
      },
    },

    // Cau hinh dang nhap voi google
    google: {
      enable: true,
      loginOptions: {
        prompt: 'select_account',
        oneTapEnabled: false,
        scopes: ['email'],
      },
      clientId: environment.authen.googleAuthClientID,
    },
  },
};

export const AUTHEN_POLICY_HUTECH: ICoreAuthModuleConfig = {
  application: {
    appKey: environment.authen.appKey,
    apiVersion: API_VERSIONs.VERSION_2_0_0,
    authVersion: AuthVersion.VERSION_2,
    apiVersionHeader: 'X-Api-Version',
    tokenType: 'JWT',
    authDomain: API_ENDPOINTS.auth,
    fileV2: API_ENDPOINTS.permission_v2_file_v2,
    branch: 'HUTECH',
  },

  globalPolicies: GlobalPolcies,

  defaultAuth: {
    reCaptcha: {
      enable: true,
      secretKey: environment.authen.reCapchaSecretKey,
      enableReCaptchaAfterError: 5,
    },
    typeAccount: {
      useDefault: false,
      enable: false,
      types: [
        {
          id: 'MOBILE_HUTECH',
          key: 'MOBILE_HUTECH',
          displayText: 'auth.component.login.form.SV_DHCD_AccounType',
          enableLanguage: true,
          show: true,
          default: true,
        }
      ]
    },
    loginByUsernameAndPassword: {
      enable: true,
    },
    client_sso: environment.client_sso
  },

  socialNetworkAuth: {
    facebook: {
      enable: false,
      secretKey: environment.authen.facebookAuthSecretKey,
      loginOptions: {
        scope:
          'pages_messaging,pages_messaging_subscriptions,email,pages_show_list,manage_pages',
        return_scopes: true,
        enable_profile_selector: true,
      },
    },

    // Cau hinh dang nhap voi google
    google: {
      enable: true,
      loginOptions: {
        prompt: 'select_account',
        oneTapEnabled: false,
        scopes: ['email'],
      },
      clientId: environment.authen.googleAuthClientID,
    },
  },
};

export const AUTHEN_POLICY_ROYAL: ICoreAuthModuleConfig = {
  application: {
    appKey: environment.authen.appKey,
    apiVersion: API_VERSIONs.VERSION_2_0_0,
    authVersion: AuthVersion.VERSION_2,
    apiVersionHeader: 'X-Api-Version',
    tokenType: 'JWT',
    authDomain: API_ENDPOINTS.auth,
    fileV2: API_ENDPOINTS.permission_v2_file_v2,
    branch: 'ROYAL', // ROYAL | UEF
  },

  globalPolicies: GlobalPolcies,

  defaultAuth: {
    reCaptcha: {
      enable: true,
      secretKey: environment.authen.reCapchaSecretKey,
      enableReCaptchaAfterError: 5,
    },
    typeAccount: {
      useDefault: true, // Default NHAN_VIEN - SINH_VIEN
      enable: true,
    },
    loginByUsernameAndPassword: {
      enable: true,
    },
    client_sso: environment.client_sso
  },

  socialNetworkAuth: {
    facebook: {
      enable: false,
      secretKey: environment.authen.facebookAuthSecretKey,
      loginOptions: {
        scope:
          'pages_messaging,pages_messaging_subscriptions,email,pages_show_list,manage_pages',
        return_scopes: true,
        enable_profile_selector: true,
      },
    },

    // Cau hinh dang nhap voi google
    google: {
      enable: true,
      loginOptions: {
        prompt: 'select_account',
        oneTapEnabled: false,
        scopes: ['email'],
      },
      clientId: environment.authen.googleAuthClientID,
    },
  },
};

export const AUTHEN_POLICY_SINHVIEN_HUTECH: ICoreAuthModuleConfig = {
  application: {
    appKey: environment.authen.appKey,
    apiVersion: API_VERSIONs.VERSION_2_0_0,
    authVersion: AuthVersion.VERSION_2,
    apiVersionHeader: 'X-Api-Version',
    tokenType: 'JWT',
    authDomain: API_ENDPOINTS.auth,
    fileV2: API_ENDPOINTS.permission_v2_file_v2,
    branch: 'SINHVIEN_HUTECH', // ROYAL | UEF,
    useCustomLoginPageURL: environment.authen.customLoginPageURL
  },
  globalPolicies: GlobalPolcies,
  defaultAuth: {
    reCaptcha: {
      enable: true,
      secretKey: environment.authen.reCapchaSecretKey,
      enableReCaptchaAfterError: 5,
    },
    typeAccount: {
      useDefault: false, // Default NHAN_VIEN - SINH_VIEN
      enable: true,
      types: environment.authen.accountTypes,
    },
    loginByUsernameAndPassword: {
      enable: true,
    },
    client_sso: environment.client_sso
  },
  socialNetworkAuth: {
    facebook: {
      enable: false,
      secretKey: environment.authen.facebookAuthSecretKey,
      loginOptions: {
        scope:
          'pages_messaging,pages_messaging_subscriptions,email,pages_show_list,manage_pages',
        return_scopes: true,
        enable_profile_selector: true,
      },
    },

    // Cau hinh dang nhap voi google
    google: {
      enable: true,
      loginOptions: {
        prompt: 'select_account',
        oneTapEnabled: false,
        scopes: ['email'],
      },
      clientId: environment.authen.googleAuthClientID,
    },
  },
};
